import { CommunityChannelLimitSettings } from './lib/community-channel';
import { OAuth2Scope } from './lib/oauth-client';
import { SaasSubscriptionBasePlanType } from './lib/saas-subscription';

export const kPseudoCreatorUrlCodeForPreview = '--bio-preview--';
export const kPseudoCreatorIdForPreview = '__PSEUDO_CREATOR_ID_FOR_PREVIEW__';

export const kSignupSessionIdLocalStorageKey = '__SIGNUP_SESSION_ID__';

export const kOnboardingAIEchoSessionIdLocalStorageKey =
  '__ONBOARDING_AI_ECHO_SESSION_ID__';

export const kPredefinedOAuth2Scopes: OAuth2Scope[] = [
  'user:basic_info',
  'community:followers',
  'community:subscribers',
  'leads:manage',
  'store:activities',
];

export const kDefaultImplicitOAuth2Scopes: OAuth2Scope[] = ['user:basic_info'];

export const kDefaultCommunityChannelLimitSettings: CommunityChannelLimitSettings =
  {
    [SaasSubscriptionBasePlanType.BEAUTIFY]: {
      maxChannels: 1,
      maxMembersPerChannel: 500,
    },
    [SaasSubscriptionBasePlanType.EXPERT]: {
      maxChannels: 2,
      maxMembersPerChannel: 2500,
    },
    [SaasSubscriptionBasePlanType.COMMUNITY]: {
      maxChannels: 3,
      maxMembersPerChannel: 5000,
    },
    [SaasSubscriptionBasePlanType.PRO]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    // legacy plan, not used any more.
    [SaasSubscriptionBasePlanType.CREATOR_PRO]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.REAL_ESTATE_STARTER]: {
      maxChannels: 3,
      maxMembersPerChannel: 2500,
    },
    [SaasSubscriptionBasePlanType.REAL_ESTATE_PRO]: {
      maxChannels: 5,
      maxMembersPerChannel: 5000,
    },
    [SaasSubscriptionBasePlanType.REAL_ESTATE_STAR]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.EXPERT_COACH_LAUNCH]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.EXPERT_COACH_PRO]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.EXPERT_COACH_AUTHORITY]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.REAL_ESTATE_AGENT]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.REAL_ESTATE_PRO_AGENT]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.REAL_ESTATE_TOP_PRODUCER]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.BEAUTY_LIFESTYLE_CREATOR]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.BEAUTY_LIFESTYLE_PRO]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.BEAUTY_LIFESTYLE_ICON]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.AI_PDF_CREATOR]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.ECHO_ME_AI_AGENT]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.ECHO_ME_FREE]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.ECHO_ME_SOLO]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.ECHO_ME_SPARK]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
    [SaasSubscriptionBasePlanType.ECHO_ME_SURGE]: {
      maxChannels: 0, // 0 means unlimited
      maxMembersPerChannel: 0, // 0 means unlimited
    },
  };

export const US_STATES = [
  'AK',
  'AL',
  'AR',
  'AS',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'GU',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VI',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
];
